module.exports = __webpack_public_path__ + "img/tablet.ad62aa74.svg";